<template>
    <a href="#">
        <img 
            alt='Premium' 
            :src="iconSrc" 
            class='premium' 
            :style="`width:${size ?? 16}px; height:${size ?? 16}px`" 
            v-if="!hasPremium" 
        />
    </a>
</template>

<script>
export default {
    props: {
        baseData: Object,
        size: String,
        icon: {
            type: String,
            default: '/static/images/create/crown-24.png' // значение по умолчанию
        }
    },
    computed: {
        hasPremium() {
            const user = this.baseData?.viewingUser;
            if (!user) return false;
            if (!user.permissions) return false;
            if (!user.permissions.activePlans) return false;
            return user.permissions.activePlans.length > 0;
        },
        iconSrc() {
            return this.icon;
        }
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
    img {
        position: relative;
        bottom: 2px;
    }
</style>